import styled from 'styled-components';
import { Card } from 'styles';

export const Numeral = styled.div<StyleProps>`
  align-items: center;
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 50%;
  display: flex;
  height: 31px;
  width: 31px;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;

  > p {
    line-height: 1;
  }
`;

export const CardHeader = styled(Card.Header)`
  padding-top: 24px;
`;
